import { render } from "./SaleQuote.vue?vue&type=template&id=4e71690e&scoped=true"
import script from "./SaleQuote.vue?vue&type=script&lang=js"
export * from "./SaleQuote.vue?vue&type=script&lang=js"

import "./SaleQuote.vue?vue&type=style&index=0&id=4e71690e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e71690e"]])

export default __exports__